// extracted by mini-css-extract-plugin
export var arrow = "_c1-2";
export var label = "_c1-1";
export var reminder = "_c1-0";